<mat-card>
    <mat-card-content>
        <div class="head" fxLayout="row">
            <div class="titleLeft">
                <title-back [addTitle]="true" [Title]="'Role Database'" (back)="back()"></title-back>
            </div>
            <div class="btnb">
                <div class="records" *ngIf="!loading">
                    <mat-form-field appearance="outline">
                        <input matInput (ngModelChange)="applyFilter($event)" placeholder="Search" ngModel>
                        <i matSuffix class="flaticon-search"></i>
                    </mat-form-field>
                </div>
                <logzy-reports-table [downloadButtons]="true" [pageName]="'role_master'"></logzy-reports-table>
                <button class="add addBtn" mat-raised-button (click)="openDD()">
                    Add Role
                </button>
            </div>
        </div>
        <logzy-table-loader *ngIf="loading"></logzy-table-loader>
        <div class="content" *ngIf="!loading" fxLayout="column">
            <div fxFlex="100" class="responsive-table">
                <ng-container *ngIf="!dd_roleList?.data.length">
                    <logzy-billu part1="No " part2="entries " part3="here." font="14px"></logzy-billu>
                </ng-container>
                <ng-container *ngIf="dd_roleList?.data.length">
                    <mat-table [dataSource]="dd_roleList" multiTemplateDataRows [class.row-selected]="selectedRow != null">
                        <ng-container matColumnDef="name">
                            <mat-header-cell *matHeaderCellDef>Role Name</mat-header-cell>
                            <mat-cell *matCellDef="let element" (click)="viewRoleMaster(element)">
                                <span class="roleName">{{ element.name}}</span>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="type">
                            <mat-header-cell *matHeaderCellDef>Role Type</mat-header-cell>
                            <mat-cell *matCellDef="let element">{{ element.type_display}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="description">
                            <mat-header-cell *matHeaderCellDef>Description</mat-header-cell>
                            <mat-cell *matCellDef="let element">{{ element.description ?? '-'}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="active">
                            <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <mat-chip-list>
                                    <div *ngIf="element.is_active; else inactive">
                                        <mat-chip color="primary" class="primaryChip" selected="{{element.is_active}}"
                                            (click)="viewRoleMaster(element)">Active</mat-chip>
                                    </div>
                                    <ng-template #inactive>
                                        <mat-chip>Inactive</mat-chip>
                                    </ng-template>
                                </mat-chip-list>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="actions">
                            <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
                            <mat-cell class="actionIcon" *matCellDef="let element">
                                <i id="ESI" [ngClass]="editing? 'flaticon-checked':'flaticon-pencil-tool'"
                                    (click)="viewRoleMaster(element)"></i>
                                <i class="flaticon-view" (click)="viewRoleMaster(element)"></i>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="expandedDetail">
                            <mat-cell class="w100" *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
                                <div class="example-element-detail w100"
                                    [@detailExpand]="element === selectedRow ? 'expanded' : 'collapsed'">
                                    <ng-container *ngIf="element === selectedRow">
                                        <access-select class="w100" [dataSource1]="element"></access-select>
                                    </ng-container>
                                </div>
                            </mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row @rowsAnimation *matRowDef="let element; columns: displayedColumns" class="example-element-row"
                            [class.example-expanded-row]="selectedRow === element"></mat-row>
                        <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"  [class.blur]="update"></mat-row>
                    </mat-table>
                    <div class="loadingData" [class.d-none]="!update">
                        <logzy-gear-loader></logzy-gear-loader>
                    </div>
                    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10" aria-label="Select page of roles"
                        [length]="pageLength" (page)="pageChanged($event)">
                    </mat-paginator>
                </ng-container>
            </div>
        </div>
    </mat-card-content>
</mat-card>